import { OrganizationProfileUrls, urls } from "../../urls";

export const useOrganizationProfileUrls = (): OrganizationProfileUrls => urls.app.organizationProfile;
